import { Parse } from 'parse';


//user가 payout요청시 실행되는 함수.
//요청한 정보에 대해 money class에 추가 및 payout class에 추가
export default async function payoutRequest(paymentRequest, userInfo, payoutMethod){
  let payoutRequestResult=false;// return 값
  const credit = await new Promise((resolve, reject)=>{
    let credit=0;
    const multiplier = Math.pow(10, 2 || 0);
    const moneyQuery = new Parse.Query(Parse.Object.extend('Money'));

    moneyQuery.limit(999999999);
    moneyQuery.equalTo('user', Parse.User.current());
    moneyQuery.find().then((result)=>{
      for(let i in result){
        if(result[i].get("money"))
          credit+=result[i].get("money");
      }
      credit= Math.round(credit * multiplier) / multiplier;
      resolve(credit);
    }).catch((error)=>{ console.log(error); reject(error); })
  }); // 현재 user가 소유한 크레딧 값.

  //유저가 요청한 값이 현재 크레딧 값 보다 크거나 100보다 작을 경우 false를 리턴한다.
  if(credit<paymentRequest || paymentRequest<100)
    return false;


//money class에 요청한 값 추가해주기.
  const Money = Parse.Object.extend('Money');
  const money = new Money();
  const acl = new Parse.ACL();
  acl.setReadAccess(Parse.User.current().id, true);
  acl.setWriteAccess(Parse.User.current().id, false);
  acl.setRoleReadAccess('adminSettlement', true);
  acl.setRoleWriteAccess('adminSettlement', false);

  money.setACL(acl);
  money.set("user",Parse.User.current());
  money.set("money",-paymentRequest);
  money.set("title","Payout Request");

  await money.save().then(async(objectId)=>{
    const Payout = Parse.Object.extend('Payout');
    const payout = new Payout();
    const acl = new Parse.ACL();
    acl.setReadAccess(Parse.User.current().id, true);
    acl.setWriteAccess(Parse.User.current().id, false);
    //payout_manager 권한추가
    // acl.setReadAccess(payout_manager.id, true);
    // acl.setWriteAccess(payout_manager.id, true);
    acl.setPublicReadAccess(false);
    acl.setPublicWriteAccess(false);
    acl.setRoleReadAccess('admin', true);
    acl.setRoleWriteAccess('admin', true);

    payout.setACL(acl);
    payout.set("userInfo",userInfo);
    payout.set("payoutStatus",false);
    payout.set("payoutMethod",payoutMethod);
    payout.set("user",Parse.User.current());
    payout.set("moneyId",objectId);
    await payout.save();
    payoutRequestResult=true;
  }).catch((err)=>{
    console.log('payout add catch error');
    console.log(err);
    payoutRequestResult=false;
  })

return payoutRequestResult;
}
